module.exports = __webpack_public_path__ + "static/media/defaultimg.27d6a679.jpg";